export const PROVIDER_SERVICE_LISTING_SEARCH_ROUTES = {
  get: '/hlx/provider-service-listings/search',
};
